import { useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { OrderService } from '../support/services/api/index';

export default function useOrder(inicialData) {
  const queryClient = useQueryClient();
  const [isCreating, setCreatingOrder] = useState(false);
  const [isCreated, setOrderCreated] = useState(false);
  const [data, setData] = useState(inicialData ?? null);

  const changeDataAttributes = (newData: object) => setData({ ...data, ...newData });

  const changeDataAttribute = (attribute:string, newData) => {
    setData({ ...data, [attribute]: newData });
  };

  const resetOrder = (dataToReset) => (dataToReset
    ? setData(dataToReset)
    : inicialData
      ? setData(inicialData)
      : setData(null));

  const mutations = {
    createOrder: useMutation(
      OrderService().create,
      {
        onSuccess: () => queryClient.invalidateQueries('orders'),
        onError: () => setCreatingOrder(false),
      },
    ),
  };

  const createOrder = async (order, success) => {
    setCreatingOrder(true);
    await mutations.createOrder.mutateAsync({ body: order },
      {
        onSuccess: (res) => {
          success(res);
          setCreatingOrder(false);
          setOrderCreated(true);
        },
      });
  };

  const updateFreeFreight = (newFreeFreightAttribute: object) => changeDataAttribute('freeFreight', { ...data.freeFreight, ...newFreeFreightAttribute });

  return ({
    sharedStates: {
      ...data,
    },
    commands: {
      changeDataAttribute,
      changeDataAttributes,
      resetOrder,
      updateFreeFreight,
      createOrder,
    },
    metaStates: {
      isCreated,
      isCreating,
    },
  });
}
